export default __webpack_public_path__ + "static/media/LinkFill.aa5c96d9.svg";